import { BlogSection } from '@/types/blog';

export const emotionaleDimensionSection: BlogSection = {
  id: 'emotionale-dimension',
  title: 'Die emotionale Dimension deiner Krypto-Investments',
  content: `
    <p>
      Neurowissenschaftliche Erkenntnisse zeigen, dass Finanzentscheidungen stark von emotionalen Faktoren beeinflusst werden. Diese psychologische Komponente wird im volatilen Krypto-Markt besonders deutlich:
    </p>

    <ul>
      <li>In Phasen starker Kurssteigerungen dominiert oft <strong>Euphorie</strong>, die zu überhasteten Entscheidungen führen kann</li>
      <li>Bei Kurseinbrüchen kann <strong>Angst</strong> irrationale Verkäufe auslösen</li>
      <li>Die <strong>Unsicherheit</strong> bezüglich steuerlicher Verpflichtungen verstärkt emotionalen Stress</li>
    </ul>

    <p>
      Klarheit über deine steuerlichen Pflichten reduziert diese emotionale Belastung erheblich und ermöglicht dir, Entscheidungen rational und selbstbewusst zu treffen – ein zentraler Aspekt gesunder Finanzpsychologie.
    </p>
  `
};
